import type { TranslationKey } from "./en";

const es: Partial<Record<TranslationKey, string>> = {
  "lang.label": "Idioma",
  "lang.select": "Seleccionar idioma",
  "theme.toggle": "Cambiar tema",
  "theme.light": "Modo claro",
  "theme.dark": "Modo oscuro",
  "brand.name": "GuardAI de G-Data Labs",
  "brand.short": "GuardAI",
  "brand.subtitle": "Patrulla de Seguridad",
  "brand.guardSystem": "Sistema de Guardias",
  "console.director": "Consola de Director",
  "console.admin": "Consola de Administrador",
  "console.supervisor": "Consola de Supervisor",
  "role.administrator": "Administrador",
  "role.director": "Director",
  "role.supervisor": "Supervisor",
  "role.guard": "Guardia de Seguridad",
  "nav.dashboard": "Panel",
  "nav.liveActivity": "Actividad en Vivo",
  "nav.devices": "Dispositivos",
  "nav.schedules": "Horarios",
  "nav.calendar": "Calendario",
  "nav.alerts": "Alertas",
  "nav.checkpoints": "Puntos de control",
  "nav.reports": "Informes",
  "nav.reportBuilder": "Creador de Informes",
  "nav.askAi": "Preguntar a la IA",
  "nav.admin": "Administración",
  "nav.settings": "Configuración",
  "nav.deploy": "Despliegue",
  "nav.scanMap": "Mapa de Escaneos",
  "nav.users": "Gestión de Usuarios",
  "common.save": "Guardar",
  "common.cancel": "Cancelar",
  "common.submit": "Enviar",
  "common.delete": "Eliminar",
  "common.edit": "Editar",
  "common.search": "Buscar",
  "common.filter": "Filtrar",
  "common.export": "Exportar",
  "common.clear": "Limpiar",
  "common.viewAll": "Ver todo",
  "common.back": "Atrás",
  "common.close": "Cerrar",
  "common.confirm": "Confirmar",
  "common.add": "Añadir",
  "common.refresh": "Actualizar",
  "common.loading": "Cargando…",
  "common.saving": "Guardando…",
  "common.saved": "Guardado",
  "common.error": "Error",
  "common.noData": "Sin datos",
  "common.required": "Obligatorio",
  "common.optional": "Opcional",
  "common.yes": "Sí",
  "common.no": "No",
  "common.all": "Todos",
  "common.none": "Ninguno",
  "common.name": "Nombre",
  "common.status": "Estado",
  "common.location": "Ubicación",
  "common.time": "Hora",
  "common.date": "Fecha",
  "common.actions": "Acciones",
  "common.today": "hoy",
  "domain.scanEvent": "Evento de escaneo",
  "domain.scanEvents": "Eventos de escaneo",
  "domain.checkpoint": "Punto de control",
  "domain.checkpoints": "Puntos de control",
  "domain.hospital": "Hospital",
  "domain.hospitals": "Hospitales",
  "domain.guard": "Guardia",
  "domain.guards": "Guardias",
  "domain.device": "Dispositivo",
  "domain.devices": "Dispositivos",
  "domain.patrol": "Patrulla",
  "domain.security": "Seguridad",
  "domain.shift": "Turno",
  "domain.station": "Estación",
  "search.placeholder": "Buscar guardias, ubicaciones o escaneos…",
  "notif.title": "Notificaciones",
  "notif.empty": "No hay notificaciones nuevas",
  "notif.viewAll": "Ver Todas las Notificaciones",
  "notif.missedCheckpoint": "Alerta de Punto de Control Omitido",
  "status.active": "Activo",
  "status.inactive": "Inactivo",
  "status.online": "En línea",
  "status.offline": "Desconectado",
  "status.pending": "Pendiente",
  "status.approved": "Aprobado",
  "status.denied": "Denegado",
  "status.flagged": "Marcado",
  "status.completed": "Completado",
  "status.missed": "Omitido",
  "status.onDuty": "De Servicio",
  "status.offDuty": "Fuera de Servicio",
  "auth.signIn": "Iniciar sesión",
  "auth.signingIn": "Iniciando sesión…",
  "auth.signOut": "Cerrar Sesión",
  "auth.username": "Usuario",
  "auth.password": "Contraseña",
  "auth.loginFailed": "Error al iniciar sesión",
  "auth.tagline": "Los guardias de seguridad escanean su credencial en cualquier estación y los supervisores ven las actualizaciones al instante en un panel seguro.",
  "dashboard.title": "Centro de Patrulla de Seguridad",
  "dashboard.subtitle": "Monitoreo en tiempo real en todos los puntos de control",
  "dashboard.totalScans": "Escaneos Totales",
  "dashboard.activeGuards": "Guardias Activos",
  "dashboard.checkpoints": "Puntos de Control",
  "dashboard.openAlerts": "Alertas Abiertas",
  "dashboard.recentActivity": "Actividad Reciente",
  "dashboard.noActivity": "Sin actividad reciente",
  "live.title": "Actividad de Patrulla en Vivo",
  "live.subtitle": "Un flujo en tiempo real de cada escaneo de credencial a medida que ocurre",
  "live.empty": "Aún no hay actividad",
  "live.waiting": "Esperando el próximo escaneo…",
  "devices.title": "Dispositivos de Patrulla Conectados",
  "devices.subtitle": "Estado de cada dispositivo de escaneo en el campo",
  "devices.lastSeen": "Visto por última vez",
  "devices.battery": "Batería",
  "devices.none": "No hay dispositivos conectados",
  "schedules.title": "Horarios de Patrulla",
  "schedules.subtitle": "Asignar guardias a turnos y puntos de control",
  "schedules.addShift": "Añadir Turno",
  "schedules.none": "Aún no hay horarios",
  "alerts.title": "Alertas de Seguridad",
  "alerts.subtitle": "Puntos de control omitidos y eventos marcados que requieren atención",
  "alerts.none": "No hay alertas activas",
  "alerts.allClear": "Todo en orden: nada requiere atención.",
  "alerts.acknowledge": "Reconocer",
  "alerts.resolve": "Resolver",
  "reports.title": "Informes de Seguridad",
  "reports.subtitle": "Cobertura de patrullas, volumen de escaneos y análisis de integridad",
  "reports.builderTitle": "Creador de Informes",
  "reports.builderSubtitle": "Diseñe informes profesionales: sin necesidad de programar.",
  "reports.generate": "Generar Informe",
  "reports.noData": "No hay datos para este informe",
  "ask.title": "Preguntar a la IA",
  "ask.greeting": "¿En qué puedo ayudarte hoy?",
  "ask.placeholder": "Pregunta cualquier cosa sobre tus patrullas, guardias o escaneos…",
  "ask.send": "Enviar",
  "ask.thinking": "Pensando…",
  "admin.title": "Administración del Sistema",
  "admin.subtitle": "Gestionar acceso, aprobaciones y estado del sistema",
  "admin.pendingApplications": "Solicitudes Pendientes",
  "admin.systemHealth": "Estado del Sistema",
  "admin.uptime": "Tiempo de Actividad",
  "admin.storage": "Almacenamiento",
  "admin.users": "Usuarios",
  "admin.latency": "Latencia",
  "users.title": "Gestión de Usuarios",
  "users.subtitle": "Añadir, editar y desactivar cuentas de la plataforma",
  "users.addUser": "Añadir Usuario",
  "users.none": "No se encontraron usuarios",
  "settings.title": "Configuración",
  "settings.subtitle": "Gestiona tu cuenta y preferencias",
  "settings.account": "Cuenta",
  "settings.appearance": "Apariencia",
  "settings.notifications": "Notificaciones",
  "settings.language": "Idioma",
  "deploy.title": "Planificador de Despliegue",
  "deploy.subtitle": "Planificar, capturar y verificar la ubicación de los puntos de control",
  "deploy.plan": "Planificar",
  "deploy.capture": "Capturar",
  "deploy.verify": "Verificar",
  "map.title": "Mapa de Escaneos",
  "map.subtitle": "Dónde se están realizando los escaneos de credenciales en las instalaciones",
  "map.noScans": "No hay escaneos para mostrar",
  "profile.account": "Cuenta",
  "profile.settings": "Configuración",
  "profile.help": "Ayuda y Soporte",
  "profile.darkMode": "Modo Oscuro",
  "profile.viewProfile": "Ver perfil",
  "footer.copyright": "© 2026 G-Data Labs. Todos los derechos reservados.",
  "footer.terms": "Términos de Uso",
  "footer.privacy": "Política de Privacidad",
  // ── Auto-added: full dashboard content translations ──
  "admin.addGuard": "Añadir guardia",
  "admin.addNewGuard": "Añadir nuevo guardia",
  "admin.addRoute": "Añadir ruta",
  "admin.alertEmail": "Correo de notificación de alertas",
  "admin.avgResponse": "Respuesta media",
  "admin.checkpointTimeout": "Tiempo de espera del punto de control (minutos)",
  "admin.checkpointsCount": "Puntos de control ({n})",
  "admin.colBadge": "Credencial",
  "admin.colContact": "Contacto",
  "admin.colGuard": "Guardia",
  "admin.colLastActive": "Última actividad",
  "admin.colRole": "Rol",
  "admin.colRoutes": "Rutas",
  "admin.deactivatedPreviewDesc": "Así es como los administradores ven una cuenta desactivada.",
  "admin.deactivatedPreviewTitle": "Vista previa de guardia desactivado",
  "admin.difficultyEasy": "Fácil",
  "admin.difficultyHard": "Difícil",
  "admin.difficultyMedium": "Media",
  "admin.employeeId": "ID de empleado:",
  "admin.errorAddGuard": "No se pudo añadir el guardia. Inténtalo de nuevo.",
  "admin.errorAllFields": "Todos los campos son obligatorios.",
  "admin.errorLoadDirectory": "No se puede cargar el directorio de guardias en este momento.",
  "admin.fieldEmail": "Correo electrónico",
  "admin.fieldEmergencyContact": "Contacto de emergencia",
  "admin.fieldEmployeeId": "ID de empleado de Emory",
  "admin.fieldFullName": "Nombre completo",
  "admin.fieldPhone": "Teléfono",
  "admin.fieldRole": "Rol",
  "admin.fieldTempPassword": "Contraseña temporal",
  "admin.gpsThreshold": "Umbral de precisión del GPS (metros)",
  "admin.guardId": "ID de guardia:",
  "admin.loadingDirectory": "Cargando el directorio de guardias…",
  "admin.moreCheckpoints": "+{n} puntos de control más",
  "admin.noGuards": "No se encontraron guardias. Añade tu primer guardia para empezar.",
  "admin.noRoutesAssigned": "Sin rutas asignadas",
  "admin.notGenerated": "No generada",
  "admin.passwordPolicy": "Política de contraseñas",
  "admin.passwordPolicyDesc": "Exigir contraseñas seguras",
  "admin.patrolRoutes": "Rutas de patrulla",
  "admin.placeholderTempPassword": "Establece una contraseña temporal",
  "admin.resetSessions": "Restablecer todas las sesiones",
  "admin.roleAdmin": "Administrador",
  "admin.roleDirector": "Director",
  "admin.roleGuard": "Guardia",
  "admin.roleSupervisor": "Supervisor",
  "admin.saveConfiguration": "Guardar configuración",
  "admin.searchGuards": "Buscar guardias...",
  "admin.securitySettings": "Configuración de seguridad",
  "admin.sessionTimeout": "Tiempo de espera de la sesión",
  "admin.sessionTimeoutDesc": "Cierre de sesión automático tras inactividad",
  "admin.statusDeactivated": "Desactivado",
  "admin.statusLabel": "Estado:",
  "admin.statusSuspended": "Suspendido",
  "admin.storageUsed": "Almacenamiento usado",
  "admin.systemConfiguration": "Configuración del sistema",
  "admin.systemStatus": "Estado del sistema",
  "admin.tabBadges": "Generador de credenciales",
  "admin.tabGuards": "Gestión de guardias",
  "admin.tabRoutes": "Gestión de rutas",
  "admin.tabSettings": "Configuración del sistema",
  "admin.timeout1Hour": "1 hora",
  "admin.timeout2Hours": "2 horas",
  "admin.timeout30Min": "30 minutos",
  "admin.timeout4Hours": "4 horas",
  "admin.totalScans": "Escaneos totales",
  "admin.twoFactor": "Autenticación de dos factores",
  "admin.twoFactorDesc": "Exigir 2FA a todos los supervisores",
  "admin.viewBadge": "Ver credencial",
  "alerts.acknowledged": "Reconocida",
  "alerts.activeAlerts": "Alertas activas",
  "alerts.allLocationsHealthy": "Todas las ubicaciones en buen estado",
  "alerts.allPriorities": "Todas las prioridades",
  "alerts.allStatus": "Todos los estados",
  "alerts.allTypes": "Todos los tipos",
  "alerts.apiError": "Error de API",
  "alerts.assignedTo": "Asignada a:",
  "alerts.critical": "Crítica",
  "alerts.distanceAway": "a {n} m",
  "alerts.exportTitle": "Exportar datos de alertas",
  "alerts.filters": "Filtros",
  "alerts.guardLabel": "Guardia {name}",
  "alerts.high": "Alta",
  "alerts.invalidScan": "Escaneo no válido",
  "alerts.issuesDetected": "{n} problemas detectados",
  "alerts.loadFailed": "Error al cargar las alertas",
  "alerts.loadFailedHint": "verifique que el punto de conexión de alertas esté desplegado.",
  "alerts.loadingAlerts": "Cargando alertas...",
  "alerts.low": "Baja",
  "alerts.medium": "Media",
  "alerts.noInvalidScans": "No hay escaneos no válidos en el último lote.",
  "alerts.noneMatchFilters": "No se encontraron alertas que coincidan con sus filtros",
  "alerts.refreshTitle": "Actualizar alertas",
  "alerts.resolved": "Resuelta",
  "alerts.scanExceptions": "Excepciones de escaneo de patrulla",
  "alerts.scanExceptionsSubtitle": "Escaneos no válidos o errores de API procedentes de los dispositivos de campo",
  "alerts.tryAgain": "Intentar de nuevo",
  "alerts.typeEmergency": "Emergencia",
  "alerts.typeMissedCheckpoint": "Punto de control omitido",
  "alerts.typeSystem": "Sistema",
  "alerts.unknownGuard": "desconocido",
  "ask.accessDenied": "Acceso denegado",
  "ask.accessDeniedDesc": "La función Preguntar a la IA está restringida a los administradores.",
  "ask.askNow": "Preguntar ahora",
  "ask.askedTimesOne": "Preguntado {n} vez",
  "ask.askedTimesOther": "Preguntado {n} veces",
  "ask.closeHistory": "Cerrar historial",
  "ask.dateAtTime": "{date} a las {time}",
  "ask.encryptedPrivate": "Análisis cifrado y privado",
  "ask.errorMessage": "Lo siento, no pude procesar esa pregunta. Esto puede deberse a un problema de conexión o a una consulta no admitida. Intenta reformular tu pregunta o vuelve a intentarlo en un momento.",
  "ask.exampleInvalidScans": "¿Qué ubicaciones registraron más escaneos NO VÁLIDOS esta semana?",
  "ask.exampleMissedScans": "Muéstrame los guardias que omitieron 3 o más escaneos en los últimos 7 días.",
  "ask.exampleNoScansToday": "Enumera las ubicaciones que no han recibido ningún escaneo hoy.",
  "ask.exampleOvernightScans": "¿Cuántos escaneos se registraron durante la noche entre las 22:00 y las 06:00?",
  "ask.frequentlyAsked": "Preguntas frecuentes",
  "ask.hideSql": "Ocultar consulta SQL",
  "ask.history": "Historial",
  "ask.inputPlaceholder": "Pregunta algo como «¿Qué ubicaciones tuvieron menos escaneos ayer?»",
  "ask.noHistory": "Aún no hay historial. Haz una pregunta para comenzar.",
  "ask.noQueriesMatching": "No hay consultas que coincidan con «{q}»",
  "ask.rowCountOne": "{n} fila",
  "ask.rowCountOther": "{n} filas",
  "ask.searchPlaceholder": "Buscar consultas anteriores...",
  "ask.showSql": "Mostrar consulta SQL",
  "ask.subtitle": "Pregunta sobre el cumplimiento de patrullas, puntos de control omitidos, el desempeño de los guardias o las tendencias por ubicación.",
  "ask.tagline": "Basado en datos de patrullaje en tiempo real",
  "ask.thisWeek": "Esta semana",
  "ask.today": "Hoy",
  "ask.yesterday": "Ayer",
  "auth.applyToJoin": "Solicita unirte a nuestro equipo",
  "auth.email": "Correo electrónico",
  "auth.enterCredentials": "Introduce tus credenciales para acceder al sistema.",
  "auth.needAccess": "¿Necesitas acceso al sistema de seguridad?",
  "deploy.addFloor": "+ Piso",
  "deploy.addUnplannedCheckpoint": "Agregar punto de control no planificado",
  "deploy.address": "Dirección",
  "deploy.allSaved": "Todo guardado",
  "deploy.area": "Área",
  "deploy.areaDescription": "Área / descripción",
  "deploy.areaLabel": "Área:",
  "deploy.areaPlaceholder": "Entrada de urgencias, Suite administrativa 200…",
  "deploy.areaSuite": "Área / Suite",
  "deploy.cameraError": "Error de cámara:",
  "deploy.cancelScan": "Cancelar escaneo",
  "deploy.captureWalkthrough": "Recorrido de captura",
  "deploy.capturedProgress": "{done} / {total} capturados",
  "deploy.checkpointsCount": "Puntos de control ({n})",
  "deploy.ckStatusCaptured": "capturado",
  "deploy.ckStatusInstalled": "instalado",
  "deploy.ckStatusPlanned": "planificado",
  "deploy.ckStatusVerified": "verificado",
  "deploy.clickAnywhereToPlace": "Haga clic en cualquier lugar para colocar el marcador",
  "deploy.clickFloorPlan": "Haga clic en el plano…",
  "deploy.complete": "¡Completado!",
  "deploy.completionReport": "Informe de finalización",
  "deploy.contactLabel": "Contacto:",
  "deploy.contactPhone": "Teléfono de contacto",
  "deploy.createAndCapture": "Crear y capturar",
  "deploy.createProject": "Crear proyecto",
  "deploy.creating": "Creando…",
  "deploy.dismiss": "descartar",
  "deploy.editingCheckpoint": "Editando punto de control",
  "deploy.fileFormats": "PNG, JPG o PDF",
  "deploy.floor": "Piso",
  "deploy.floorColon": "Piso:",
  "deploy.floorLabel": "Piso:",
  "deploy.floorN": "Piso {n}",
  "deploy.floorPlanAlt": "Plano del piso {n}",
  "deploy.generated": "Generado:",
  "deploy.gettingGps": "Obteniendo GPS…",
  "deploy.gpsFailedRetry": "Error de GPS — reintentar",
  "deploy.grabGps": "Obtener GPS",
  "deploy.hospitalNameRequired": "Nombre del hospital *",
  "deploy.initials": "Iniciales: ______",
  "deploy.installVerify": "Instalar y verificar",
  "deploy.installedAlt": "instalado",
  "deploy.installedVerifiedProgress": "{done} / {total} instalados y verificados",
  "deploy.locationDetail": "Detalle de ubicación",
  "deploy.locationDetailPlaceholder": "A la izquierda de las puertas principales, sobre el desinfectante…",
  "deploy.locationDetailShort": "A la izquierda de las puertas principales…",
  "deploy.locationLabel": "Ubicación:",
  "deploy.markInstalledVerified": "Marcar como instalado y verificado",
  "deploy.newCheckpoint": "Nuevo punto de control",
  "deploy.newDeploymentProject": "Nuevo proyecto de despliegue",
  "deploy.newProject": "Nuevo proyecto",
  "deploy.newUnplannedCheckpoint": "Nuevo punto de control no planificado",
  "deploy.noCameraFound": "No se encontró ninguna cámara",
  "deploy.noCheckpointsHint": "Haga clic en «Colocar marcador» y luego en el plano.",
  "deploy.noCheckpointsYet": "Aún no hay puntos de control.",
  "deploy.noProjectSelected": "Ningún proyecto seleccionado",
  "deploy.noProjectSelectedHint": "Seleccione un proyecto existente o cree uno nuevo arriba.",
  "deploy.noProjectsYet": "Aún no hay proyectos.",
  "deploy.notYetVerified": "Aún no verificados",
  "deploy.notes": "Notas",
  "deploy.notesLabel": "Notas:",
  "deploy.notesPlaceholder": "Notas de referencia, detalles de montaje…",
  "deploy.placeCardHere": "Coloque la tarjeta AQUÍ (de la captura):",
  "deploy.placeMarker": "Colocar marcador",
  "deploy.placementNotes": "Notas de colocación",
  "deploy.placementNotesPlaceholder": "1,5 m de altura, pared de ladrillo, adhesivo permanente…",
  "deploy.placementReferenceAlt": "referencia de colocación",
  "deploy.print": "Imprimir",
  "deploy.printChecklist": "Imprimir lista de verificación",
  "deploy.qrPlaced": "QR colocado",
  "deploy.qrPrefix": "QR:",
  "deploy.recapture": "Volver a capturar",
  "deploy.retakeInstalledPhoto": "Volver a tomar foto de instalación",
  "deploy.retakePhoto": "Volver a tomar foto",
  "deploy.reverify": "Volver a verificar",
  "deploy.saveCapture": "Guardar captura",
  "deploy.scanAgain": "Escanear de nuevo",
  "deploy.scanQrCode": "Escanear código QR",
  "deploy.scanToVerify": "Escanear para verificar",
  "deploy.scanVerified": "Escaneo verificado",
  "deploy.scannedPrefix": "Escaneado:",
  "deploy.selectProject": "Seleccionar un proyecto…",
  "deploy.selectProjectShort": "Seleccionar proyecto…",
  "deploy.selectProjectToCapture": "Seleccione un proyecto para comenzar a capturar.",
  "deploy.selectProjectToVerify": "Seleccione un proyecto para comenzar a verificar.",
  "deploy.simulation3d": "Simulación 3D",
  "deploy.siteContactName": "Nombre del contacto del sitio",
  "deploy.speechNotSupported": "El reconocimiento de voz no es compatible con este navegador.",
  "deploy.statusCapturing": "captura",
  "deploy.statusComplete": "completo",
  "deploy.statusFabricating": "fabricación",
  "deploy.statusInstalling": "instalación",
  "deploy.statusPlanning": "planificación",
  "deploy.stop": "Parada",
  "deploy.stopNumber": "Parada n.º {n}",
  "deploy.stopVoice": "Detener",
  "deploy.takeInstalledPhoto": "Tomar foto de instalación",
  "deploy.takePhoto": "Tomar foto",
  "deploy.total": "Total",
  "deploy.unnamed": "Sin nombre",
  "deploy.unnamedLower": "sin nombre",
  "deploy.unsavedChanges": "Cambios sin guardar...",
  "deploy.uploadFloorPlan": "Subir plano",
  "deploy.uploadFloorPlanFor": "Suba un plano para el piso {n}",
  "deploy.uuidMatched": "¡UUID coincide! QR verificado.",
  "deploy.uuidMismatch": "UUID no coincide. Tarjeta QR incorrecta.",
  "deploy.uuidPrefix": "UUID:",
  "deploy.verifiedCheckpoints": "Puntos de control verificados",
  "deploy.verifiedCount": "Verificados",
  "deploy.voice": "Voz",
  "deploy.walkthroughChecklistStops": "Lista de verificación del recorrido de despliegue — {n} paradas",
  "devices.appVersion": "Versión de la app",
  "devices.deviceManagement": "Gestión de dispositivos",
  "devices.emptyHint": "Los dispositivos conectados aparecerán aquí en cuanto envíen telemetría.",
  "devices.geofences": "Geocercas",
  "devices.hoursAgo": "hace {n} h",
  "devices.justNow": "Ahora mismo",
  "devices.lastLocation": "Última ubicación",
  "devices.locateOnMap": "Localizar dispositivo en el mapa",
  "devices.minutesAgo": "hace {n} min",
  "devices.never": "Nunca",
  "devices.noDevicesFound": "No se encontraron dispositivos",
  "devices.noGpsData": "Sin datos de GPS",
  "devices.refreshStatus": "Actualizar estado",
  "devices.violations": "Infracciones",
  "geofence.acknowledge": "Confirmar",
  "geofence.acknowledged": "Confirmada",
  "geofence.acknowledging": "Confirmando...",
  "geofence.actionHeader": "Acción",
  "geofence.allGeofences": "Todas las geocercas",
  "geofence.create": "Crear geocerca",
  "geofence.createdBy": "Creado por",
  "geofence.createdDate": "Fecha de creación",
  "geofence.deleteConfirmBody": "Esta acción no se puede deshacer. La geocerca se eliminará permanentemente.",
  "geofence.deleteConfirmTitle": "¿Eliminar geocerca?",
  "geofence.drawPolygon": "Dibujar polígono en el mapa",
  "geofence.drawPolygonHint": "Haga clic en el mapa para agregar puntos. El polígono debe tener al menos 3 puntos. Puntos actuales: {n}",
  "geofence.edit": "Editar geocerca",
  "geofence.enterName": "Ingrese un nombre para la geocerca",
  "geofence.failedCreate": "Error al crear la geocerca",
  "geofence.failedDelete": "Error al eliminar la geocerca",
  "geofence.failedLoad": "Error al cargar las geocercas",
  "geofence.failedSave": "Error al guardar la geocerca",
  "geofence.failedUpdate": "Error al actualizar la geocerca",
  "geofence.filterByGeofence": "Filtrar por geocerca",
  "geofence.geofenceHeader": "Geocerca",
  "geofence.gpsCoordinates": "Coordenadas GPS",
  "geofence.hoursAgo": "hace {n} h",
  "geofence.justNow": "Justo ahora",
  "geofence.management": "Gestión de geocercas",
  "geofence.managementSubtitle": "Defina zonas seguras y supervise las infracciones de los límites",
  "geofence.minPoints": "El polígono debe tener al menos 3 puntos",
  "geofence.minutesAgo": "hace {n} min",
  "geofence.nameLabel": "Nombre de la geocerca",
  "geofence.namePlaceholder": "p. ej., Entrada principal, Estacionamiento A",
  "geofence.noViolations": "No se detectaron infracciones",
  "geofence.noViolationsHint": "Todos los dispositivos están dentro de sus geocercas designadas.",
  "geofence.noneConfigured": "No hay geocercas configuradas para su ubicación.",
  "geofence.noneYet": "Aún no hay geocercas",
  "geofence.noneYetCanCreate": "Cree su primera geocerca para comenzar con la supervisión de límites.",
  "geofence.pointN": "Punto {n}:",
  "geofence.polygonPoints": "Puntos del polígono ({n})",
  "geofence.preview": "Vista previa",
  "geofence.save": "Guardar geocerca",
  "geofence.selectHospitalAlert": "Seleccione un hospital",
  "geofence.selectHospitalOption": "Seleccionar un hospital...",
  "geofence.unacknowledged": "Sin confirmar",
  "geofence.unacknowledgedCount": "{n} sin confirmar",
  "geofence.violationsSubtitle": "Supervise y confirme las infracciones de los límites",
  "geofence.violationsTitle": "Infracciones de geocercas",
  "help.callNow": "Llamar ahora",
  "help.comingSoon": "Próximamente",
  "help.docsComingSoon": "Documentación próximamente.",
  "help.emailSupport": "Soporte por correo electrónico",
  "help.escalateIssue": "Escalar problema",
  "help.guardHeadline": "Ayuda y soporte para guardias",
  "help.guidesFaq": "Guías y preguntas frecuentes",
  "help.incidentEscalation": "Escalamiento de incidentes",
  "help.incidentEscalationDesc": "Informa interrupciones, fallos de quiosco o problemas urgentes de escaneo.",
  "help.intro": "Ponte en contacto con el equipo de Patrulla de Seguridad de Emory o revisa los pasos rápidos para solucionar problemas.",
  "help.phoneHotline": "Línea telefónica directa",
  "help.phoneHotlineValue": "(404) 555-0199 • 24/7",
  "help.quickTips": "Consejos rápidos",
  "help.sendEmail": "Enviar correo",
  "help.supervisorHeadline": "Ayuda y soporte para supervisores",
  "help.support": "Soporte",
  "help.tipAskAi": "Usa la página Preguntar a la IA para obtener datos históricos antes de contactar con soporte.",
  "help.tipRefresh": "Actualiza la página si los escaneos parecen retrasados o desactualizados.",
  "help.tipReinstall": "Los guardias pueden reinstalar la PWA desde la página de configuración cuando el ícono desaparece.",
  "home.activeCheckpoints": "Puntos de control activos",
  "home.activeCheckpointsTooltip": "Número total de ubicaciones físicas de códigos QR registradas actualmente en este hospital.",
  "home.addNewMarker": "Agregar nuevo marcador",
  "home.allHospitalsAggregated": "Todos los hospitales (agregados)",
  "hospitals.allAggregated": "Todos los hospitales (agregados)",
  "home.building": "Edificio",
  "home.buildingFloor": "{building} - Piso {floor}",
  "home.cancelPlacement": "Cancelar colocación",
  "home.chartScans": "Escaneos:",
  "home.checkpointName": "Nombre del punto de control",
  "home.checkpointNamePlaceholder": "p. ej. Finanzas (Oeste)",
  "home.checkpointsScanned": "Puntos de control escaneados",
  "home.chooseCheckpoint": "— Elige un punto de control —",
  "home.cleared": "LIQUIDADO",
  "home.clickToPlace": "Haz clic en cualquier parte del mapa para colocar un nuevo marcador.",
  "home.comparingScanVolume": "Comparando el volumen de escaneos activos en todos los sitios registrados",
  "home.complianceRate": "Tasa de cumplimiento",
  "home.complianceRateTooltip": "Porcentaje de puntos de control registrados que se han escaneado al menos una vez durante el turno actual.",
  "home.complianceRateValue": "Tasa de cumplimiento: {n}%",
  "home.confirmDeleteCheckpoint": "¿Estás seguro de que deseas eliminar este punto de control? Esta acción no se puede deshacer.",
  "home.createCustomCheckpoint": "+ Crear punto de control personalizado...",
  "home.deleteMarker": "Eliminar marcador",
  "home.dragToReposition": "Arrastra los marcadores para reposicionarlos. Los cambios se guardan automáticamente.",
  "home.editModeOn": "Modo de edición ACTIVADO",
  "home.editPositions": "Editar posiciones",
  "home.failedDeleteLocation": "Error al eliminar la ubicación",
  "home.failedSaveLocation": "Error al guardar la ubicación",
  "home.floor": "Piso",
  "home.floorAbbr": "P. {n}",
  "home.floorN": "Piso {n}",
  "home.headerSubtitle": "Verificación de patrullas en tiempo real y estado de carga del concentrador",
  "home.hospitalPerformanceComparison": "Comparación de rendimiento de hospitales",
  "home.hospitalSecurity": "Seguridad del hospital",
  "home.hub": "Concentrador: {hub}",
  "home.internalServerError": "Error interno del servidor",
  "home.lastHour": "Última hora",
  "home.lastScan": "Último escaneo",
  "home.lastUpdated": "Última actualización:",
  "home.legendError": "Error",
  "home.legendInvalid": "No válido",
  "home.legendOk": "Correcto",
  "home.liveSystem": "Sistema en vivo",
  "home.loadingCheckpoints": "Cargando puntos de control...",
  "home.loadingComplianceData": "Cargando datos de cumplimiento...",
  "home.loadingUploads": "Cargando cargas...",
  "home.mapLast30Days": "Últimos 30 días",
  "home.mapLast7Days": "Últimos 7 días",
  "home.mapLastQuarter": "Último trimestre",
  "home.mapSubtitle": "Seguimiento de patrullas en tiempo real y estado de los puntos de control",
  "home.mapTitle": "Mapa de actividad en vivo del hospital",
  "home.mapTodaysScans": "Escaneos de hoy",
  "home.moreCheckpoints": "+ {n} puntos de control más",
  "home.noCheckpointsConfigured": "No hay puntos de control configurados para este hospital.",
  "home.noCheckpointsLoaded": "No se cargaron puntos de control. Comprueba la conexión a la base de datos o agrega uno manualmente a continuación.",
  "home.noUploadsToday": "No se registraron cargas hoy.",
  "home.numberOfScans": "Número de escaneos",
  "home.pendingClear": "LIQUIDACIÓN PENDIENTE",
  "home.placeCheckpoint": "Colocar punto de control",
  "home.positionLabel": "Posición:",
  "home.qrPayload": "Carga útil del QR",
  "home.qrPayloadPlaceholder": "p. ej. FINANCE_WEST",
  "home.recentPatrolActivity7Days": "Actividad de patrulla reciente (7&nbsp;días)",
  "home.recentScans7Days": "Escaneos recientes (7&nbsp;días)",
  "home.recentScansTooltip": "Número total de escaneos de patrulla cargados y verificados correctamente en los últimos 7 días.",
  "home.registeredCheckpoints": "Puntos de control registrados",
  "home.roleDashboard": "Panel de {role}:",
  "home.saveCheckpoint": "Guardar punto de control",
  "home.scanner": "Escáner: {serial}",
  "home.scansCount": "{n} escaneos",
  "home.selectCheckpoint": "Seleccionar punto de control",
  "home.tooltipPosition": "Posición",
  "home.unknownHospital": "Hospital desconocido",
  "home.uploadsByShift": "Cargas por turno",
  "home.viewingHospital": "Hospital visualizado:",
  "landing.addressInfo": "Información de la dirección",
  "landing.agreeTerms": "Acepto los términos del servicio",
  "landing.agreeTermsDetail": "Entiendo que el acceso al sistema de patrullas de seguridad está sujeto a la aprobación del supervisor y que toda la información proporcionada es precisa y completa.",
  "landing.availableShifts": "Turnos disponibles (selecciona todos los que correspondan)",
  "landing.bulletIntegrity": "Análisis de integridad para escaneos omitidos y eventos marcados.",
  "landing.bulletMonitoring": "Supervisión en tiempo real de cada vestíbulo, entrada y pasillo.",
  "landing.bulletWorkspace": "Espacio de trabajo unificado para supervisores con búsqueda instantánea e información con IA.",
  "landing.city": "Ciudad",
  "landing.completeAndAgree": "Completa todos los campos obligatorios y acepta los términos.",
  "landing.confirmPassword": "Confirmar contraseña",
  "landing.confirmYourPassword": "Confirma tu contraseña",
  "landing.createPassword": "Crea una contraseña segura",
  "landing.dateOfBirth": "Fecha de nacimiento",
  "landing.emailAddress": "Correo electrónico",
  "landing.emailRegistered": "Este correo electrónico ya está registrado.",
  "landing.emailRegisteredUseDifferent": "Este correo electrónico ya está registrado. Usa otro correo electrónico.",
  "landing.emergencyContact": "Contacto de emergencia",
  "landing.emergencyContactName": "Nombre del contacto de emergencia",
  "landing.emergencyContactPhone": "Teléfono del contacto de emergencia",
  "landing.fillRequiredContinue": "Completa todos los campos obligatorios antes de continuar.",
  "landing.firstName": "Nombre",
  "landing.lastName": "Apellido",
  "landing.next": "Siguiente",
  "landing.passwordsNoMatch": "Las contraseñas no coinciden",
  "landing.percentComplete": "{p}% completado",
  "landing.personalInfo": "Información personal",
  "landing.phoneNumber": "Número de teléfono",
  "landing.phoneRegistered": "Este número de teléfono ya está registrado.",
  "landing.phoneRegisteredUseDifferent": "Este número de teléfono ya está registrado. Usa otro número de teléfono.",
  "landing.relChild": "Hijo/a",
  "landing.relFriend": "Amigo/a",
  "landing.relOther": "Otro",
  "landing.relParent": "Padre/Madre",
  "landing.relSibling": "Hermano/a",
  "landing.relSpouse": "Cónyuge",
  "landing.relationship": "Parentesco",
  "landing.requestAccessSubtitle": "Completa este formulario para solicitar acceso al sistema de patrullas de seguridad.",
  "landing.requestAccessTitle": "Solicitar acceso al sistema",
  "landing.requestSubmitted": "Solicitud de cuenta enviada",
  "landing.requestSubmittedApproval": "Podrás iniciar sesión con tus credenciales una vez aprobada. Este proceso suele tardar de 1 a 2 días hábiles.",
  "landing.requestSubmittedThanks": "Gracias por solicitar acceso al sistema de patrullas de seguridad. Tu solicitud se ha enviado y está pendiente de aprobación por parte de los supervisores.",
  "landing.requestedRole": "Rol solicitado",
  "landing.returnHome": "Volver al inicio",
  "landing.returnToLogin": "Volver al inicio de sesión",
  "landing.roleAvailability": "Rol y disponibilidad",
  "landing.securityDirector": "Director de seguridad",
  "landing.securitySupervisor": "Supervisor de seguridad",
  "landing.selectEllipsis": "Seleccionar...",
  "landing.shiftDay": "Turno de día (6:00 a 14:00)",
  "landing.shiftEvening": "Turno de tarde (14:00 a 22:00)",
  "landing.shiftHolidays": "Días festivos",
  "landing.shiftNight": "Turno de noche (22:00 a 6:00)",
  "landing.shiftOnCall": "De guardia",
  "landing.shiftWeekends": "Fines de semana",
  "landing.signInSubheading": "Usa tus credenciales de supervisor o guardia para continuar.",
  "landing.signInToGuard": "Iniciar sesión en Guard",
  "landing.somethingWrong": "Algo salió mal.",
  "landing.state": "Estado",
  "landing.stepOf": "Paso {n} de 4",
  "landing.streetAddress": "Dirección",
  "landing.submitApplication": "Enviar solicitud",
  "landing.submitFailed": "No se pudo enviar la solicitud. Inténtalo de nuevo.",
  "landing.submitting": "Enviando...",
  "landing.termsOfService": "Términos del servicio",
  "landing.zipCode": "Código postal",
  "live.action": "Acción",
  "live.activityFeed": "Flujo de actividad",
  "live.asOf": "A las {time}",
  "live.colCoordinate": "Coordenada",
  "live.colDateTime": "Fecha y hora",
  "live.colDistance": "Distancia",
  "live.deviceLocation": "(Ubicación del dispositivo)",
  "live.filterAll": "Toda la actividad",
  "live.filterInvalid": "Escaneos no válidos",
  "live.filterValid": "Escaneos válidos",
  "live.floor": "Planta {n}",
  "live.freshFix": "(Posición reciente)",
  "live.loadingActivity": "Cargando actividad de patrulla…",
  "live.metersAway": "a {n} m",
  "live.noGpsData": "Sin datos de GPS",
  "live.noScansFilter": "No hay escaneos que coincidan con este filtro.",
  "live.syncData": "Sincronizar datos",
  "live.timeframe": "Período",
  "live.unknownHospital": "Hospital desconocido",
  "live.unknownLocation": "Ubicación desconocida",
  "live.view3d": "Vista 3D",
  "live.view3dWorld": "Ver el mundo 3D de este punto de control",
  "map.allHospitals": "Todos los hospitales",
  "map.autoRefresh": "Actualización automática",
  "map.autoRefreshTitle": "Actualización automática cada 30 s",
  "map.dark": "Oscuro",
  "map.expandLegend": "Expandir leyenda",
  "map.gpsDisclaimer": "Las posiciones de escaneo reflejan la precisión del GPS del dispositivo. Las señales en interiores pueden variar entre 10 y 50 m respecto a la ubicación real.",
  "map.heatmap": "Mapa de calor",
  "map.heatmapTitle": "Alternar mapa de calor de densidad",
  "map.legend": "Leyenda",
  "map.light": "Claro",
  "map.limitedWarning": "El mapa muestra un máximo de {max} escaneos. Acote el intervalo de tiempo o el filtro de hospital para ver datos específicos.",
  "map.loadFailed": "Error al cargar los escaneos",
  "map.loadingScans": "Cargando escaneos…",
  "map.mapStyle": "Estilo de mapa: {name}",
  "map.markers": "Marcadores",
  "map.minimizeLegend": "Minimizar leyenda",
  "map.noGpsScans": "No se encontraron escaneos con etiqueta GPS para este intervalo de tiempo.",
  "map.pageSubtitle": "Vista geográfica en vivo de dónde ocurrieron los eventos de escaneo.",
  "map.pageTitle": "Mapa de escaneos GuardAI",
  "map.popupHospital": "Hospital:",
  "map.popupScanner": "Escáner:",
  "map.popupTime": "Hora:",
  "map.rangeCustom": "Intervalo personalizado",
  "map.rangeLast24h": "Últimas 24 h",
  "map.rangeLast30d": "Últimos 30 días",
  "map.rangeLast7d": "Últimos 7 días",
  "map.rangeLastHour": "Última hora",
  "map.showingMaxScans": "Mostrando {shown} (máx.) de {total} escaneos",
  "map.snapToBuilding": "Ajustar al edificio",
  "map.snapToBuildingTitle": "Ajusta los puntos GPS hacia los centros de los edificios para contrarrestar la deriva del GPS en interiores",
  "map.switchToDark": "Cambiar a mapa oscuro",
  "map.switchToLight": "Cambiar a mapa claro",
  "map.to": "a",
  "map.totalScans": "{total} escaneos",
  "map.unknownHospital": "Desconocido",
  "map.updatedAt": "Actualizado {time}",
  "reportBuilder.addWidget": "Agregar un widget",
  "reportBuilder.aiAssistant": "Asistente de informes con IA",
  "reportBuilder.aiPlaceholder": "Describe el informe que quieres — p. ej. «recuentos de escaneos por hospital del último mes con un gráfico de barras». O dibuja un diseño en papel y sube una foto.",
  "reportBuilder.aiSummaryHint": "Haz clic en «Generar» para redactar observaciones a partir de los datos de tu informe.",
  "reportBuilder.allHospitals": "Todos los hospitales",
  "reportBuilder.allTime": "Todo el período",
  "reportBuilder.assistantUnavailable": "El asistente no está disponible en este momento.",
  "reportBuilder.author": "Autor",
  "reportBuilder.beta": "Beta",
  "reportBuilder.buildItForMe": "Créalo por mí",
  "reportBuilder.buildTogether": "Construyámoslo juntos",
  "reportBuilder.canvasEmpty": "Tu lienzo está vacío",
  "reportBuilder.canvasEmptyHint": "Agrega un widget desde la barra de herramientas de arriba, haz clic en un campo de datos a la izquierda o empieza con una plantilla.",
  "reportBuilder.captionPlaceholder": "Leyenda (opcional)",
  "reportBuilder.color": "Color",
  "reportBuilder.compareAgainst": "Comparar con",
  "reportBuilder.configure": "Configurar",
  "reportBuilder.copySuffix": "(copia)",
  "reportBuilder.couldntSave": "No se pudo guardar:",
  "reportBuilder.dataFields": "Campos de datos",
  "reportBuilder.dataFieldsHint": "Haz clic en cualquier campo para añadir un widget prediseñado a tu informe.",
  "reportBuilder.dataSource": "Fuente de datos",
  "reportBuilder.dateFrom": "Desde {date}",
  "reportBuilder.dateFromLabel": "Fecha desde",
  "reportBuilder.dateThrough": "Hasta {date}",
  "reportBuilder.dateToLabel": "Fecha hasta",
  "reportBuilder.dayOfWeekOpt": "Día de la semana",
  "reportBuilder.describeOrSketch": "Describe el informe que quieres o adjunta un boceto.",
  "reportBuilder.dismiss": "Descartar",
  "reportBuilder.done": "Listo",
  "reportBuilder.donutStyle": "Estilo de anillo",
  "reportBuilder.draftedOffline": " · redactado sin conexión",
  "reportBuilder.duplicate": "Duplicar",
  "reportBuilder.example1": "Recuentos de escaneos por hospital del último mes, con un gráfico de barras",
  "reportBuilder.example2": "Actividad de patrulla diaria con horas pico y dispositivos activos",
  "reportBuilder.example3": "Cobertura de puntos de control: escaneados vs. no escaneados por hospital",
  "reportBuilder.exportCsv": "CSV (datos)",
  "reportBuilder.exportFailed": "Error al exportar:",
  "reportBuilder.exportHtml": "HTML (para compartir)",
  "reportBuilder.exportPdf": "PDF (listo para imprimir)",
  "reportBuilder.exportPng": "Imagen PNG",
  "reportBuilder.exportPrint": "Imprimir",
  "reportBuilder.exportSlides": "Listo para diapositivas (HTML)",
  "reportBuilder.exportTryPdf": "Prueba con PDF (Imprimir).",
  "reportBuilder.exportXls": "Excel (.xls)",
  "reportBuilder.fieldTitle": "Título",
  "reportBuilder.filterFloor": "Filtro: planta",
  "reportBuilder.filterHospital": "Filtro: hospital",
  "reportBuilder.floorPlaceholder": "p. ej. L1, 5, Plaza",
  "reportBuilder.generate": "Generar",
  "reportBuilder.generateBtn": "Generar",
  "reportBuilder.generatedBy": "Generado por GuardAI · © {year} G-Data Labs. Todos los derechos reservados.",
  "reportBuilder.generating": "Generando…",
  "reportBuilder.group": "Grupo",
  "reportBuilder.groupBy": "Agrupar por",
  "reportBuilder.hideSettings": "Ocultar ajustes",
  "reportBuilder.horizontal": "horizontal",
  "reportBuilder.imageTooLarge": "Esa imagen es un poco grande — usa una de menos de 6 MB.",
  "reportBuilder.imageUrlPlaceholder": "URL de la imagen (opcional)",
  "reportBuilder.includeLogo": "Incluir el logotipo de GuardAI",
  "reportBuilder.loadFailed": "No se pudieron cargar los datos.",
  "reportBuilder.lookAt": "Mira el {target}",
  "reportBuilder.maxRows": "Filas máximas",
  "reportBuilder.metric": "Métrica",
  "reportBuilder.moreSettings": "Más ajustes",
  "reportBuilder.moveDown": "Mover hacia abajo",
  "reportBuilder.moveUp": "Mover hacia arriba",
  "reportBuilder.next": "Siguiente",
  "reportBuilder.noDataSelection": "No hay datos para esta selección",
  "reportBuilder.noImageUploaded": "No se subió ninguna imagen",
  "reportBuilder.noLayout": "No pude convertir eso en un diseño — intenta describir las métricas y cómo agruparlas.",
  "reportBuilder.noSummary": "No se generó ningún resumen.",
  "reportBuilder.noWidgetsYet": "Este informe aún no tiene widgets.",
  "reportBuilder.optionalSubtitle": "Subtítulo opcional",
  "reportBuilder.orientation": "Orientación",
  "reportBuilder.period": "Período: {range}",
  "reportBuilder.preparedBy": "Preparado por {name}",
  "reportBuilder.preview": "Vista previa",
  "reportBuilder.previewHint": "Así se exportará e imprimirá tu informe. Usa el botón Exportar de arriba para descargarlo.",
  "reportBuilder.regenerate": "Regenerar",
  "reportBuilder.remove": "Eliminar",
  "reportBuilder.removeImage": "Quitar imagen",
  "reportBuilder.reportImage": "Imagen del informe",
  "reportBuilder.reportTitle": "Título del informe",
  "reportBuilder.reportsAnalytics": "Informes y análisis",
  "reportBuilder.saveAsTemplate": "Guardar el informe actual como plantilla compartida",
  "reportBuilder.savedAt": "Guardado a las {time}",
  "reportBuilder.savedReports": "Informes guardados",
  "reportBuilder.secondSeriesLabel": "Etiqueta de la segunda serie",
  "reportBuilder.secondSeriesMetric": "Métrica de la segunda serie",
  "reportBuilder.secondSeriesSource": "Fuente de la segunda serie",
  "reportBuilder.selectWidget": "Selecciona un widget para configurarlo.",
  "reportBuilder.seriesB": "Serie B",
  "reportBuilder.sketch": "Boceto",
  "reportBuilder.sketchAlt": "boceto",
  "reportBuilder.sort": "Ordenar",
  "reportBuilder.sortLabelAsc": "Nombre, A → Z",
  "reportBuilder.sortLabelDesc": "Nombre, Z → A",
  "reportBuilder.sortValueAsc": "Valor, de menor a mayor",
  "reportBuilder.sortValueDesc": "Valor, de mayor a menor",
  "reportBuilder.startFromTemplate": "Empezar con una plantilla",
  "reportBuilder.startNewReport": "Empezar un nuevo informe",
  "reportBuilder.stepOf": "Paso {n} de {total}",
  "reportBuilder.subtitle": "Subtítulo",
  "reportBuilder.summaryFailed": "No se pudo generar el resumen.",
  "reportBuilder.targetAiBar": "barra del asistente de IA",
  "reportBuilder.targetCanvas": "lienzo del informe",
  "reportBuilder.targetConfigPanel": "panel de configuración",
  "reportBuilder.targetDataFields": "panel de campos de datos",
  "reportBuilder.targetExport": "botón de exportar",
  "reportBuilder.targetPreview": "interruptor de vista previa",
  "reportBuilder.targetSave": "botón de guardar",
  "reportBuilder.targetTemplates": "botón de plantillas",
  "reportBuilder.targetToolbar": "barra de herramientas de widgets",
  "reportBuilder.templates": "Plantillas",
  "reportBuilder.textPlaceholder": "Escribe tu texto. Usa ## para un encabezado y **negrita** para resaltar.",
  "reportBuilder.thinking": "Pensando…",
  "reportBuilder.title": "Generador de informes",
  "reportBuilder.total": "Total",
  "reportBuilder.try": "Prueba:",
  "reportBuilder.untitledReport": "Informe sin título",
  "reportBuilder.uploadSketchTitle": "Sube una foto de un diseño de informe dibujado a mano",
  "reportBuilder.vertical": "vertical",
  "reportBuilder.walkMeThrough": "Guíame paso a paso",
  "reportBuilder.widgetCountMany": "{n} widgets",
  "reportBuilder.widgetCountOne": "{n} widget",
  "reportBuilder.width": "Ancho",
  "reportBuilder.widthFull": "Completo",
  "reportBuilder.working": "Procesando…",
  "reports.activeGuards": "Guardias activos",
  "reports.asOfTime": "(a las {time})",
  "reports.averageCompliance": "Cumplimiento promedio",
  "reports.averageResponseTime": "Tiempo de respuesta promedio",
  "reports.checkpointLocationAnalysis": "Análisis de ubicaciones de puntos de control",
  "reports.checkpointsCompleted": "Puntos de control completados",
  "reports.checkpointsLoggedGps": "({n} puntos de control registrados desde datos GPS)",
  "reports.colCompliance": "Cumplimiento",
  "reports.colPerformance": "Rendimiento",
  "reports.compliance90to94": "90-94% de cumplimiento",
  "reports.compliance95": "≥95% de cumplimiento",
  "reports.complianceBelow90": "<90% de cumplimiento",
  "reports.complianceLabel": "cumplimiento",
  "reports.complianceReport": "Informe de cumplimiento",
  "reports.coverageComplianceHelp": "% de puntos de control visitados al menos una vez durante este período",
  "reports.coverageComplianceTrends": "Tendencias de cumplimiento de cobertura",
  "reports.criticalIssuesResolved": "Problemas críticos resueltos",
  "reports.currentTime": "Actual: {time}",
  "reports.dayFri": "Vie",
  "reports.dayFriday": "Viernes",
  "reports.dayMon": "Lun",
  "reports.dayMonday": "Lunes",
  "reports.daySat": "Sáb",
  "reports.daySaturday": "Sábado",
  "reports.daySun": "Dom",
  "reports.daySunday": "Domingo",
  "reports.dayThu": "Jue",
  "reports.dayThursday": "Jueves",
  "reports.dayTue": "Mar",
  "reports.dayTuesday": "Martes",
  "reports.dayWed": "Mié",
  "reports.dayWednesday": "Miércoles",
  "reports.deltaLastMonth": "+1,8% respecto al mes pasado",
  "reports.deltaLastQuarter": "+3,2% respecto al trimestre pasado",
  "reports.deltaLastWeek": "+2,1% respecto a la semana pasada",
  "reports.deltaYesterday": "+1,5% respecto a ayer",
  "reports.downloadReport": "Descargar informe",
  "reports.exceptions": "Excepciones",
  "reports.exportFormat": "Formato de exportación",
  "reports.exportReport": "Exportar informe",
  "reports.guardPerformanceAnalysis": "Análisis del rendimiento de guardias",
  "reports.heatmapCellTitle": "{location} - {label}: {pct}% de actividad",
  "reports.lessActivity": "Menos actividad",
  "reports.loadingPatrolActivity": "Cargando actividad de patrulla…",
  "reports.locationAbbreviations": "Abreviaturas de ubicaciones:",
  "reports.locationActivityHeatmap": "Mapa de calor de actividad por ubicación",
  "reports.missedCheckpoints": "Puntos de control omitidos",
  "reports.missedCount": "{n} omitidos",
  "reports.monFeb": "Feb",
  "reports.monJan": "Ene",
  "reports.monMar": "Mar",
  "reports.monthN": "Mes {n}",
  "reports.moreActivity": "Más actividad",
  "reports.noChange": "Sin cambios",
  "reports.noCoverageData": "Aún no hay datos de cobertura",
  "reports.noDataForPeriod": "Sin datos para el período",
  "reports.noScanLocations": "No hay ubicaciones de escaneo de códigos QR disponibles",
  "reports.notAvailable": "N/D",
  "reports.overallComplianceRate": "Tasa de cumplimiento general",
  "reports.patrolLocations": "Ubicaciones de patrulla",
  "reports.periodMonth": "Este mes",
  "reports.periodQuarter": "Este trimestre",
  "reports.periodToday": "Hoy",
  "reports.periodWeek": "Esta semana",
  "reports.popupCompliance": "Cumplimiento:",
  "reports.popupLast": "Último:",
  "reports.popupScans": "Escaneos:",
  "reports.qrScanLocations": "Ubicaciones de escaneo de códigos QR",
  "reports.quickExportOptions": "Opciones de exportación rápida",
  "reports.realScanData": "Datos de escaneo reales (últimas 24 h)",
  "reports.scanToSeeLocations": "Escanea códigos QR para ver ubicaciones en el mapa",
  "reports.scansCount": "{n} escaneos",
  "reports.scansThisMonth": "{n} escaneos este mes",
  "reports.scansThisQuarter": "{n} escaneos este trimestre",
  "reports.scansThisWeek": "{n} escaneos esta semana",
  "reports.scansToday": "{n} escaneos hoy",
  "reports.tabCompliance": "Cumplimiento",
  "reports.tabGuardPerformance": "Rendimiento de guardias",
  "reports.tabLocationAnalysis": "Análisis de ubicaciones",
  "reports.tabOverview": "Resumen",
  "reports.totalScans": "Escaneos totales",
  "reports.trackingLocationsGuards": "Supervisando {locations} ubicaciones y {guards} guardias.",
  "reports.trendDaily": "Tendencias de rendimiento diarias",
  "reports.trendHourly": "Tendencias de rendimiento por hora",
  "reports.trendMonthly": "Tendencias de rendimiento mensuales",
  "reports.trendTooltip": "{pct}% ({n} ubic.)",
  "reports.trendWeekly": "Tendencias de rendimiento semanales",
  "reports.validated": "Validados",
  "reports.viewDetails": "Ver detalles",
  "reports.weekN": "Semana {n}",
  "reports.weeklySummary": "Resumen semanal",
  "reports.wk1": "Sem1",
  "reports.wk2": "Sem2",
  "reports.wk3": "Sem3",
  "reports.wk4": "Sem4",
  "schedules.activeRoutes": "Rutas activas",
  "schedules.activeSchedules": "Horarios activos",
  "schedules.addNewSchedule": "Agregar nuevo horario",
  "schedules.addSchedule": "Agregar horario",
  "schedules.assignedGuard": "Guardia asignado",
  "schedules.assignedGuards": "Guardias asignados",
  "schedules.calendar": "Calendario",
  "schedules.confirmDelete": "¿Está seguro de que desea eliminar este horario?",
  "schedules.coverageGaps": "Brechas de cobertura",
  "schedules.createSchedule": "Crear horario",
  "schedules.dayFri": "Vie",
  "schedules.dayMon": "Lun",
  "schedules.daySat": "Sáb",
  "schedules.daySun": "Dom",
  "schedules.dayThu": "Jue",
  "schedules.dayTue": "Mar",
  "schedules.dayWed": "Mié",
  "schedules.daysOfWeek": "Días de la semana",
  "schedules.deleteSchedule": "Eliminar horario",
  "schedules.editSchedule": "Editar horario",
  "schedules.endTime": "Hora de fin",
  "schedules.fillRequired": "Por favor, complete todos los campos obligatorios",
  "schedules.frequency": "Frecuencia",
  "schedules.frequencyCustom": "Personalizada",
  "schedules.frequencyDaily": "Diaria",
  "schedules.frequencyWeekly": "Semanal",
  "schedules.listView": "Vista de lista",
  "schedules.morningPatrol": "Patrulla matutina",
  "schedules.nightShift": "Turno nocturno",
  "schedules.route": "Ruta",
  "schedules.scheduleName": "Nombre del horario",
  "schedules.scheduleNamePlaceholder": "p. ej., Patrulla matutina - Edificio A",
  "schedules.selectGuard": "Seleccione un guardia",
  "schedules.selectRoute": "Seleccione una ruta",
  "schedules.selectedCount": "Seleccionados: {n} punto(s) de control",
  "schedules.startTime": "Hora de inicio",
  "schedules.updateSchedule": "Actualizar horario",
  "settings.browserDesc": "UA registrado para supervisar la integridad del dispositivo.",
  "settings.browserLabel": "Navegador",
  "settings.cameraDesc": "Necesario para escanear etiquetas QR. Ajústalo en la configuración del sistema si se deniega.",
  "settings.cameraPermission": "Permiso de cámara",
  "settings.deviceIdDesc": "Huella digital almacenada con cada escaneo para el cumplimiento de auditorías.",
  "settings.deviceIdLabel": "ID del dispositivo",
  "settings.email": "Correo electrónico",
  "settings.escalationAlerts": "Alertas de escalamiento",
  "settings.fullName": "Nombre completo",
  "settings.installPwa": "Instalar como PWA",
  "settings.locationDesc": "Necesario para la verificación por GPS en cada punto de control.",
  "settings.locationPermission": "Permiso de ubicación",
  "settings.mobilePhone": "Teléfono móvil",
  "settings.notRegistered": "Aún no registrado",
  "settings.notificationDesc": "Controla qué alertas puede enviarte el equipo de supervisión.",
  "settings.notificationPreferences": "Preferencias de notificaciones",
  "settings.permGranted": "Concedido",
  "settings.permUnknown": "Desconocido",
  "settings.profileDetails": "Datos del perfil",
  "settings.profileSavedMsg": "Preferencias del perfil guardadas. Los cambios surten efecto de inmediato.",
  "settings.pwaAndroid": "Android (Chrome):",
  "settings.pwaAndroidSteps": "Menú → Instalar aplicación.",
  "settings.pwaDesktop": "Escritorio:",
  "settings.pwaDesktopSteps": "Usa el aviso de instalación del navegador en la barra de direcciones.",
  "settings.pwaIos": "iOS (Safari):",
  "settings.pwaIosSteps": "Toca Compartir → Añadir a pantalla de inicio.",
  "settings.saveProfile": "Guardar perfil",
  "settings.storedLocally": "La configuración se almacena localmente hasta que esté disponible la sincronización del perfil.",
  "settings.weeklyEmailSummary": "Resumen semanal por correo electrónico",
  "users.applicationDetails": "Detalles de la solicitud",
  "users.applicationReview": "Revisión de solicitud:",
  "users.applicationStatus": "Estado de la solicitud",
  "users.approve": "Aprobar",
  "users.approveApplication": "Aprobar solicitud",
  "users.backToApplications": "Volver a las solicitudes",
  "users.colApplicant": "Solicitante",
  "users.colRole": "Rol",
  "users.dateAdded": "Fecha de incorporación",
  "users.directoryFound": "Encontrado en la tabla employees_personal_info.",
  "users.directoryMatch": "Coincidencia en el directorio",
  "users.directoryName": "Nombre en el directorio",
  "users.email": "Correo electrónico",
  "users.filterAll": "Todas las solicitudes",
  "users.filterPending": "Pendiente de revisión",
  "users.nextSteps": "Próximos pasos",
  "users.noApplications": "No se encontraron solicitudes",
  "users.phone": "Teléfono",
  "users.phoneNumber": "Número de teléfono",
  "users.reject": "Rechazar",
  "users.rejectApplication": "Rechazar solicitud",
  "users.requestedRole": "Rol solicitado",
  "users.review": "Revisar",
  "users.statusRejected": "Rechazado",
  "users.stepBackgroundCheck": "Iniciar la verificación de antecedentes",
  "users.stepCheckLicense": "Comprobar la validez de la licencia/certificación",
  "users.stepScheduleInterview": "Programar una entrevista si se aprueba",
  "users.stepVerifyReferences": "Verificar las referencias por teléfono",
  "users.submitted": "Enviado:",
  "widget.aiSummary": "Resumen con IA",
  "widget.barChart": "Gráfico de barras",
  "widget.comparison": "Comparación",
  "widget.dataTable": "Tabla de datos",
  "widget.dayOfWeek": "Día de la semana",
  "widget.image": "Imagen",
  "widget.kpiRow": "Fila de KPI",
  "widget.lineChart": "Gráfico de líneas",
  "widget.metricCard": "Tarjeta de métrica",
  "widget.pieDonut": "Circular / Anillo",
  "widget.rankedTable": "Tabla clasificada",
  "widget.textBlock": "Bloque de texto",

  // Activity calendar
  "calendar.title": "Calendario de actividad de patrullaje",
  "calendar.subtitle": "Actividad de escaneo en cada punto de control, día a día",
  "calendar.viewMonth": "Mes",
  "calendar.viewWeek": "Semana",
  "calendar.viewDay": "Día",
  "calendar.viewList": "Lista",
  "calendar.today": "Hoy",
  "calendar.allHospitals": "Todos los hospitales",
  "calendar.totalScans": "{n} escaneos",
  "calendar.activeDays": "{n} días activos",
  "calendar.alertsCount": "{n} alertas",
  "calendar.noActivityRange": "Sin actividad de escaneo en este período.",
  "calendar.loading": "Cargando actividad…",
  "calendar.loadFailed": "Error al cargar la actividad",
  "calendar.refresh": "Actualizar",
  "calendar.colTime": "Hora",
  "calendar.colHospital": "Hospital",
  "calendar.colCheckpoint": "Punto de control",
  "calendar.colDevice": "Dispositivo",
  "calendar.colGuard": "Guardia",
  "calendar.violation": "Infracción",
  "calendar.violationsCount": "{n} infracciones",
  "calendar.scansShort": "{n} escaneos",
  "calendar.hospitalsActive": "{n} hospitales activos",
  "calendar.moreEvents": "+{n} más",
  "calendar.weekOf": "Semana del {date}",
  "calendar.dayEvents": "Eventos de escaneo",
  "calendar.hourlyDistribution": "Distribución por hora",
  "calendar.legendLess": "Menos",
  "calendar.legendMore": "Más",
  "calendar.unknownHospital": "Hospital desconocido",
  "calendar.unknownGuard": "Guardia desconocido",
  "calendar.unknownCheckpoint": "Punto de control desconocido",

  // --- Synced from en.ts: newer pages (officers, compliance, checkpoints, patrol reports) ---
  "nav.compliance": "Cumplimiento",
  "nav.officers": "Oficiales",
  "nav.patrolReports": "Informes de patrulla",
  "common.retry": "Reintentar",
  "common.collapse": "Contraer",
  "common.expand": "Expandir",
  "home.comparisonVsMapNote": "Los recuentos incluyen todos los escaneos registrados. El Mapa de Escaneos solo representa los escaneos con coordenadas GPS, por lo que su total puede ser menor.",
  "live.colOfficer": "Oficial",
  "live.unattributed": "Sin atribuir",
  "map.trailNote": "Los puntos están coloreados según la hora de escaneo. No se dibuja ninguna ruta entre escaneos: solo se muestran las ubicaciones de escaneo registradas.",
  "checkpoints.directoryTitle": "Directorio de puntos de control",
  "checkpoints.directorySubtitle": "Todos los puntos de control QR registrados, organizados por piso",
  "checkpoints.searchPlaceholder": "Buscar por nombre, código o edificio…",
  "checkpoints.countShown": "{n} puntos de control",
  "checkpoints.exportCsv": "Exportar CSV",
  "checkpoints.loadingDirectory": "Cargando puntos de control…",
  "checkpoints.empty": "No se encontraron puntos de control para este hospital.",
  "checkpoints.noFloor": "Sin asignar",
  "checkpoints.floorLabel": "Piso {n}",
  "checkpoints.colCode": "Código",
  "checkpoints.colName": "Nombre",
  "checkpoints.colBuilding": "Edificio",
  "checkpoints.colFloor": "Piso",
  "checkpoints.colLastScanned": "Último escaneo",
  "checkpoints.colTotalScans": "Escaneos totales",
  "checkpoints.colStatus": "Estado",
  "checkpoints.active": "Activo",
  "checkpoints.inactive": "Inactivo",
  "checkpoints.never": "Nunca",
  "checkpoints.untitled": "Punto de control sin nombre",
  "checkpoints.totalScans": "Escaneos totales",
  "checkpoints.compliance": "Cumplimiento",
  "checkpoints.late": "Con retraso",
  "checkpoints.missed": "Omitido",
  "checkpoints.fromDate": "Desde",
  "checkpoints.toDate": "Hasta",
  "checkpoints.clearDates": "Limpiar",
  "checkpoints.loadingHistory": "Cargando historial de escaneos…",
  "checkpoints.noScans": "No se registraron escaneos para este punto de control en el intervalo seleccionado.",
  "checkpoints.unknownDevice": "Dispositivo desconocido",
  "checkpoints.noGps": "Sin GPS",
  "checkpoints.statusOnTime": "A tiempo",
  "checkpoints.statusLate": "Con retraso",
  "checkpoints.statusMissed": "Omitido",
  "checkpoints.viewHistory": "Ver historial de escaneos",
  "compliance.title": "Cumplimiento de patrullas",
  "compliance.subtitle": "Estado de escaneo de los puntos de control según el intervalo configurado de cada ubicación.",
  "compliance.advisory": "Solo con fines informativos. Esta vista indica cuándo se escaneó por última vez cada punto de control y el tiempo restante de su intervalo de escaneo. No es una asignación de trabajo, una ruta ni una instrucción. Qué puntos de control se escanean y en qué orden sigue siendo decisión del oficial y su supervisor, sujeto a las órdenes de puesto de su empleador y a cualquier tarea de mayor prioridad.",
  "compliance.loadFailed": "No se pudo cargar el estado de cumplimiento",
  "compliance.overdue": "Vencido",
  "compliance.overdueSub": "Fuera del intervalo de escaneo",
  "compliance.dueSoon": "Por vencer",
  "compliance.dueSoonSub": "En el último cuarto del intervalo",
  "compliance.onInterval": "En intervalo",
  "compliance.onIntervalSub": "Escaneado dentro del intervalo",
  "compliance.neverScanned": "Sin escaneo registrado",
  "compliance.neverScannedSub": "No se cuenta como vencido",
  "compliance.neverScannedNoteTitle": "Por qué estos no se cuentan como vencidos:",
  "compliance.neverScannedNote": "Un punto de control sin escaneo registrado no tiene ningún intervalo que haya podido superar. Los puntos de control anteriores al seguimiento de cumplimiento se muestran así hasta que se ejecuta el relleno histórico del sitio, por lo que tratarlos como vencidos generaría una alerta para todos los puntos de control a la vez.",
  "compliance.openAlerts": "Alertas de cumplimiento abiertas",
  "compliance.checkpointStatus": "Estado de los puntos de control",
  "compliance.filterAttention": "Vencidos y por vencer",
  "compliance.filterOverdue": "Solo vencidos",
  "compliance.filterAll": "Todos los puntos de control",
  "compliance.emptyAll": "No se encontraron puntos de control para esta selección.",
  "compliance.emptyAttention": "No hay puntos de control vencidos ni por vencer.",
  "compliance.colCheckpoint": "Punto de control",
  "compliance.colStatus": "Estado",
  "compliance.colLastScan": "Último escaneo",
  "compliance.colInterval": "Intervalo",
  "compliance.colRemaining": "Tiempo en intervalo",
  "compliance.colScans24h": "Escaneos (24 h)",
  "compliance.status.OVERDUE": "Vencido",
  "compliance.status.DUE_SOON": "Por vencer",
  "compliance.status.OK": "En intervalo",
  "compliance.status.NEVER_SCANNED": "Sin escaneo registrado",
  "compliance.minutesShort": "min",
  "compliance.perDay": "por día",
  "compliance.ruleLocation": "regla de ubicación",
  "compliance.ruleHospital": "predet. del sitio",
  "compliance.truncated": "Mostrando solo los resultados más urgentes. Filtre por sitio para ver el resto.",
  "compliance.generatedAt": "Estado a fecha de",
  "compliance.rules": "Intervalos de escaneo",
  "compliance.rulesTitle": "Intervalos de escaneo",
  "compliance.rulesSubtitle": "Una regla de ubicación anula el predeterminado del sitio, que a su vez anula el predeterminado del sistema.",
  "compliance.rulesEmpty": "Sin reglas personalizadas: se aplica el predeterminado del sistema.",
  "compliance.rulesLoadFailed": "No se pudieron cargar las reglas",
  "compliance.rulesSaveFailed": "No se pudo guardar la regla",
  "compliance.rulesDeleteFailed": "No se pudo eliminar la regla",
  "compliance.rulesCreateFailed": "No se pudo crear la regla",
  "compliance.rulesInvalid": "El intervalo y el mínimo diario deben ser números",
  "compliance.systemDefault": "Predeterminado del sistema",
  "compliance.systemDefaultValue": "cada",
  "compliance.systemDefaultNote": "Los sitios sin regla propia se miden con respecto a este valor.",
  "compliance.siteWide": "Todos los puntos de control de este sitio",
  "compliance.colAppliesTo": "Se aplica a",
  "compliance.colIntervalMin": "Intervalo (min)",
  "compliance.colMinPerDay": "Mín / 24 h",
  "compliance.colActions": "Acciones",
  "compliance.addSiteDefault": "Añadir predeterminado del sitio",
  "compliance.pickSiteToAdd": "Seleccione un solo sitio para añadirle un valor predeterminado.",
  "officers.title": "Oficiales",
  "officers.subtitle": "Oficiales que inician turno con un número N para que sus escaneos se atribuyan. No son cuentas de acceso al panel.",
  "officers.add": "Añadir oficial",
  "officers.addTitle": "Añadir oficial",
  "officers.editTitle": "Editar oficial",
  "officers.loadFailed": "No se pudieron cargar los oficiales",
  "officers.saveFailed": "No se pudo guardar el oficial",
  "officers.deactivateFailed": "No se pudo desactivar el oficial",
  "officers.searchPlaceholder": "Buscar por nombre, número N o correo",
  "officers.filterActive": "Activo",
  "officers.filterInactive": "Inactivo",
  "officers.filterSuspended": "Suspendido",
  "officers.filterPending": "Pendiente de aprobación",
  "officers.filterRejected": "Rechazado",
  "officers.filterAll": "Todos los estados",
  "officers.onShiftCount": "En turno actualmente:",
  "officers.empty": "Aún no hay oficiales. Añade uno para empezar a atribuir escaneos.",
  "officers.emptySearch": "Ningún oficial coincide con esa búsqueda.",
  "officers.colOfficer": "Oficial",
  "officers.colNNumber": "Número N",
  "officers.colSite": "Sitio",
  "officers.colStatus": "Estado",
  "officers.colShift": "Turno actual",
  "officers.colActions": "Acciones",
  "officers.status.ACTIVE": "Activo",
  "officers.status.PENDING": "Pendiente de aprobación",
  "officers.status.INACTIVE": "Inactivo",
  "officers.status.SUSPENDED": "Suspendido",
  "officers.status.REJECTED": "Rechazado",
  "officers.onShiftSince": "En turno desde",
  "officers.offShift": "Fuera de turno",
  "officers.scans": "escaneos",
  "officers.deactivate": "Desactivar",
  "officers.deactivateTitle": "¿Desactivar oficial?",
  "officers.deactivateBody": "{name} ya no podrá iniciar turno y se cerrará cualquier turno abierto. Su historial de escaneos se conserva y sigue atribuido a él.",
  "officers.fieldNNumber": "Número N",
  "officers.fieldNNumberHint": "La N inicial se añade automáticamente si la omites.",
  "officers.fieldName": "Nombre completo",
  "officers.fieldSite": "Sitio",
  "officers.fieldEmail": "Correo electrónico",
  "officers.fieldPhone": "Teléfono",
  "officers.fieldStatus": "Estado",
  "officers.fieldStatusHint": "Solo los oficiales ACTIVOS pueden iniciar turno. Cambiar a un estado distinto de ACTIVO cierra cualquier turno abierto.",
  "officers.selectSite": "Seleccione un sitio",
  "officers.formRequired": "El número N, el nombre y el sitio son obligatorios",
  "officers.pendingTitle": "Aprobaciones de inscripción pendientes",
  "officers.selfEnrolled": "Autoinscrito",
  "officers.enrolledAt": "inició turno",
  "officers.enrollDistance": "{d} del área de escaneo registrada del sitio",
  "officers.enrollNoGps": "sin señal GPS al iniciar turno",
  "officers.enrollSiteMismatch": "Se seleccionó {chosen}, pero el GPS indicó {gps} — confirme cuál es correcto antes de aprobar.",
  "officers.pendingNote": "Estas identidades se autodeclararon en un escaneo de credencial. Sus escaneos se atribuyen provisionalmente hasta su aprobación; rechazar conserva el registro y sus escaneos para revisión.",
  "officers.approve": "Aprobar",
  "officers.reject": "Rechazar",
  "officers.approveTitle": "¿Aprobar inscripción?",
  "officers.approveBody": "Confirma a {n} como oficial en {site}. Sus escaneos pendientes siguen atribuidos y los próximos inicios de turno funcionan con normalidad.",
  "officers.approveName": "Nombre del oficial (tal como debe aparecer)",
  "officers.approveFailed": "No se pudo aprobar la inscripción",
  "officers.rejectFailed": "No se pudo rechazar la inscripción",
  "patrolReports.title": "Informes de patrulla",
  "patrolReports.subtitle": "Actividad de patrulla registrada por oficial, cobertura de puntos de control e historial de alertas de cumplimiento.",
  "patrolReports.tabOfficers": "Oficiales",
  "patrolReports.tabCoverage": "Cobertura",
  "patrolReports.tabHistory": "Historial de alertas",
  "patrolReports.loadFailed": "No se pudo cargar el informe",
  "patrolReports.badRange": "La fecha de inicio debe ser anterior o igual a la fecha de fin",
  "patrolReports.startDate": "Fecha de inicio",
  "patrolReports.endDate": "Fecha de fin",
  "patrolReports.totalScans": "Escaneos en el período",
  "patrolReports.attributed": "Atribuidos a un oficial",
  "patrolReports.unattributed": "Sin atribuir",
  "patrolReports.unattributedSub": "Escaneados sin ningún oficial en turno",
  "patrolReports.officersListed": "Oficiales listados",
  "patrolReports.noOfficers": "No hay oficiales en esta selección.",
  "patrolReports.colOfficer": "Oficial",
  "patrolReports.colSite": "Sitio",
  "patrolReports.colShifts": "Turnos",
  "patrolReports.colShiftTime": "Tiempo de turno",
  "patrolReports.colScans": "Escaneos",
  "patrolReports.colCheckpoints": "Puntos de control",
  "patrolReports.colScansHr": "Escaneos / h",
  "patrolReports.colLastScan": "Último escaneo",
  "patrolReports.fullyCovered": "Cubierto todos los días",
  "patrolReports.partiallyCovered": "Cubierto algunos días",
  "patrolReports.uncovered": "Sin escaneos en el período",
  "patrolReports.of": "de",
  "patrolReports.coverageTitle": "Cobertura de puntos de control",
  "patrolReports.coverageSort": "Puntos de control con menos cobertura primero.",
  "patrolReports.colCheckpoint": "Punto de control",
  "patrolReports.colDaysCovered": "Días cubiertos",
  "patrolReports.colExpected": "Esperado",
  "patrolReports.colStatusNow": "Estado actual",
  "patrolReports.alertsRaised": "Alertas en el período",
  "patrolReports.alertsOpen": "Aún abiertas",
  "patrolReports.alertsResolved": "Resueltas",
  "patrolReports.repeatTitle": "Puntos de control que generan alertas con más frecuencia",
  "patrolReports.colAlerts": "Alertas",
  "patrolReports.colOpen": "Abiertas",
  "patrolReports.colWorst": "Mayor retraso",
  "patrolReports.colAvgResolve": "Prom. de resolución",
  "patrolReports.colLatest": "Más reciente",
  "patrolReports.alertLog": "Registro de alertas",
  "patrolReports.noAlerts": "No hay alertas en este período.",
  "patrolReports.resolvedIn": "resuelta en",
  "patrolReports.stateResolved": "Resuelta",
  "patrolReports.stateOpen": "Abierta",
  "emailPrefs.title": "Preferencias de alertas por correo",
  "emailPrefs.subtitle": "Elige qué correos de cumplimiento recibes, por sitio.",
  "emailPrefs.loadFailed": "No se pudieron cargar las preferencias de correo",
  "emailPrefs.saveFailed": "No se pudo guardar la preferencia",
  "emailPrefs.noSites": "No hay sitios en tu lista de acceso.",
  "emailPrefs.noPreference": "Sin preferencia guardada: se aplica el valor predeterminado",
  "emailPrefs.explainer": "Los sitios donde nadie ha guardado una preferencia envían correos a todos los supervisores y directores de forma predeterminada. Guardar cualquier preferencia en un sitio lo cambia a solo las opciones explícitas.",
  "emailPrefs.overdue": "Alertas de vencidos",
  "emailPrefs.overdueHint": "Correo inmediato cuando los puntos de control superan su intervalo de escaneo",
  "emailPrefs.daily": "Resumen diario",
  "emailPrefs.dailyHint": "Un resumen de cumplimiento por día",
  "emailPrefs.officerSummary": "Resumen de actividad de oficiales",
  "emailPrefs.officerSummaryHint": "Informe semanal de actividad registrada. Desactivado a menos que te suscribas.",
  "emailPrefs.manageOthers": "Gestionar destinatarios en este sitio",
  "emailPrefs.noOthers": "No hay otros destinatarios configurados aquí.",
  "emailPrefs.enrollEmail": "email@emoryhealthcare.org",
  "emailPrefs.enrollName": "Nombre (opcional)",
  "emailPrefs.enroll": "Añadir destinatario",
  "emailPrefs.officerSummaryNote": "El resumen de actividad de oficiales es un informe programado de la actividad de escaneo registrada, con sus salvedades incluidas — no es una calificación de desempeño y nunca se envía a quien no se haya suscrito.",
  "officerMap.open": "Ver mapa del historial de escaneos",
  "officerMap.title": "Historial de escaneos",
  "officerMap.loadFailed": "No se pudo cargar el historial de escaneos",
  "officerMap.empty": "No hay escaneos con etiqueta GPS atribuidos a este oficial en el período seleccionado.",
  "officerMap.firstScan": "Primer escaneo",
  "officerMap.lastScan": "Último escaneo",
  "officerMap.scans": "escaneos",
  "officerMap.ofTotal": "de {n} escaneos",
  "officerMap.note": "Aquí solo aparecen los escaneos atribuidos a este oficial. Los escaneos realizados fuera de turno quedan sin atribuir y no se muestran.",
  "patrolReports.officersTableTitle": "Actividad registrada por oficial",


  // --- Officer detail page (synced from en.ts) ---
  "officerDetail.allOfficers": "Todos los oficiales",
  "officerDetail.backToOfficers": "Volver a Oficiales",
  "officerDetail.notFound": "Oficial no encontrado.",
  "officerDetail.loadFailed": "No se pudo cargar el oficial",
  "officerDetail.selfEnrolled": "Autoinscrito",
  "officerDetail.addedBySupervisor": "Añadido por un supervisor",
  "officerDetail.memberSince": "miembro desde {date}",
  "officerDetail.totalScans": "Escaneos totales",
  "officerDetail.shifts": "Turnos",
  "officerDetail.activeDays": "Días activos",
  "officerDetail.avgShift": "Prom. / turno",
  "officerDetail.noShiftsYet": "aún no hay turnos",
  "officerDetail.scansPerShift": "escaneos por turno",
  "officerDetail.lastActive": "Última actividad",
  "officerDetail.whereScanned": "Dónde escaneó {name}",
  "officerDetail.mapToLight": "Cambiar el mapa a mosaicos claros",
  "officerDetail.mapToDark": "Cambiar el mapa a mosaicos oscuros",
  "officerDetail.light": "Claro",
  "officerDetail.dark": "Oscuro",
  "officerDetail.noGpsScans": "No hay escaneos con etiqueta GPS para mostrar en el mapa en los últimos 30 días.",
  "officerDetail.scanActivityTitle": "Actividad de escaneo — Últimos {n} días",
  "officerDetail.noScansInDays": "No se registraron escaneos en los últimos {n} días.",
  "officerDetail.scanHistory": "Historial de escaneos",
  "officerDetail.searchScans": "Buscar escaneos…",
  "officerDetail.colDateTime": "Fecha y hora",
  "officerDetail.colLocation": "Ubicación",
  "officerDetail.colHospital": "Hospital",
  "officerDetail.colCoordinates": "Coordenadas",
  "officerDetail.noScansMatch": "Ningún escaneo coincide con “{q}”.",
  "officerDetail.showingScans": "Mostrando {shown} de {total} escaneos registrados (últimos 30 días).",
  "officerDetail.timelineRange": "{n} escaneos · del más antiguo → al más reciente",
  "officerDetail.hoverTimeline": "Pase el cursor sobre la línea de tiempo para trazar un escaneo",
  "officerDetail.timelineCaption": "Cada punto es un escaneo, ubicado según cuándo ocurrió y coloreado de azul (más antiguo) a rojo (más reciente). Pase el cursor para resaltarlo en el mapa. No se dibuja ninguna ruta entre escaneos: solo se muestran las ubicaciones de escaneo registradas.",


  // --- Scan Map anomaly/misplaced views (synced from en.ts) ---
  "map.officer": "Oficial",
  "map.clearOfficer": "Limpiar filtro de oficial",
  "map.searchOfficer": "Buscar oficial…",
  "map.misplacedTitle": "Mostrar solo los escaneos cuyo GPS quedó a más de 1 km de su punto de control",
  "map.misplacedOn": "Mal ubicados",
  "map.misplacedOff": "Mal ubicados",
  "map.anomaliesTitle": "Mostrar escaneos marcados como anómalos — desplazamiento imposible del oficial, o un escaneo representado lejos de su propio hospital",
  "map.anomalies": "Anomalías",
  "map.popupOfficer": "Oficial:",
  "map.anomalousMovement": "Anómalo — desplazamiento imposible entre los escaneos de este oficial",
  "map.anomalousHospital": "Anómalo — representado lejos de su hospital indicado",
  "map.anomalousBoth": "Anómalo — desplazamiento imposible y lejos de su hospital",
  "map.metersFromCheckpoint": "{n} m de su punto de control",
  "map.scansLabel": "escaneos",
  "map.earliest": "Más antiguo",
  "map.latest": "Más reciente",

};

export default es;
